const INTERVAL = 1500;
const MOVE = 600;
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

document.querySelectorAll(".cta_rotating-layout").forEach((layout) => {
	const wrapper = layout.querySelector(".words-wrapper");
	const list = layout.querySelector(".words");
	const originals = [...(list?.children ?? [])];
	if (!wrapper || originals.length < 2) return;

	// Drie keer dezelfde reeks: de actieve plek loopt door de middelste reeks en springt daarna onzichtbaar een reeks terug.
	const count = originals.length;
	[...Array(2)].forEach(() => originals.forEach((item) => {
		const clone = item.cloneNode(true);
		clone.setAttribute("aria-hidden", "true");
		clone.classList.remove("is-active");
		list.append(clone);
	}));
	const items = [...list.children];
	originals.forEach((item) => item.classList.remove("is-active"));

	// Eén reeks (de middelste) is voor assistieve technologie; de rest is decoratief.
	items.forEach((item, i) => item.toggleAttribute("aria-hidden", i < count || i >= count * 2));

	let active = count;
	let timer = null;

	// Houdt het actieve woord in het midden van het venster, ook als woorden over twee regels lopen.
	const place = (animate) => {
		const item = items[active];
		const offset = wrapper.clientHeight / 2 - (item.offsetTop + item.offsetHeight / 2);
		list.style.transition = animate && !reduceMotion.matches ? `transform ${MOVE}ms ease-in-out` : "none";
		list.style.transform = `translateY(${offset}px)`;
	};

	const mark = () => items.forEach((item, i) => item.classList.toggle("is-active", i === active));

	// Het venster is zo hoog als de hoogste reeks van vijf woorden, zodat de kaart ernaast niet verspringt.
	const sizeWindow = () => {
		const rows = items.slice(count, count * 2);
		const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
		let tallest = 0;
		for (let start = 0; start < rows.length; start += 1) {
			let sum = 0;
			for (let k = 0; k < Math.min(5, rows.length); k += 1) sum += rows[(start + k) % rows.length].offsetHeight + gap;
			tallest = Math.max(tallest, sum - gap);
		}
		wrapper.style.height = `${tallest}px`;
	};

	const step = () => {
		active += 1;
		mark();
		place(true);

		if (active >= count * 2) {
			// Na de beweging een reeks terug, zonder dat je het ziet.
			setTimeout(() => {
				active -= count;
				place(false);
				mark();
			}, MOVE + 50);
		}
	};

	const start = () => {
		if (timer || reduceMotion.matches) return;
		timer = setInterval(step, INTERVAL);
	};
	const stop = () => {
		clearInterval(timer);
		timer = null;
	};

	sizeWindow();
	mark();
	place(false);
	layout.classList.add("is-ready");

	// Het lettertype bepaalt de regelbreedte; na het laden opnieuw meten.
	document.fonts?.ready.then(() => {
		sizeWindow();
		place(false);
	});

	// Alleen draaien als de sectie in beeld is en de tab zichtbaar.
	new IntersectionObserver(([entry]) => (entry.isIntersecting ? start() : stop()), { threshold: 0.2 }).observe(layout);
	document.addEventListener("visibilitychange", () => (document.hidden ? stop() : null));
	window.addEventListener("resize", () => {
		sizeWindow();
		place(false);
	});
});
